import OrderDataLayer from './OrderDataLayer';
import { DataLayerAnalytics } from '../DataLayerAnalytics';
import { OrderType } from './types';
import { FlightSegment } from '@websky/graphql';
import { OrderStep } from '../types';
import { Currency } from '../../enums';

class SearchResultsDataLayer extends OrderDataLayer {
	public constructor(instance: DataLayerAnalytics) {
		super(instance);
	}

	public init(currency: Currency, promocode: string) {
		this.dataLayer.init({
			coupon: promocode,
			currency
		});
	}

	public getOrderType(): OrderType {
		return OrderType.SearchResults;
	}

	public getFlightSegments(): FlightSegment[] {
		return [];
	}

	public getOrderStatus(): OrderStep {
		return OrderStep.Booking;
	}

	public getDataLayer() {
		return this.dataLayer;
	}
}

export default SearchResultsDataLayer;
